
import React from 'react';
import { EnvelopeIcon, UserCircleIcon, IdentificationIcon, DevicePhoneMobileIcon } from '../../Icons';

export const BrokerFormStep: React.FC<any> = ({ formData, onFormChange, errors }) => {
  const idTypes = ['Cédula de ciudadanía', 'Pasaporte', 'Cédula de extranjería'];
  const countryCodes = [{ v: '+57', l: '🇨🇴 +57' }, { v: '+1', l: '🇺🇸 +1' }, { v: '+34', l: '🇪🇸 +34' }];

  const inputClass = "w-full pl-11 pr-4 py-3 border-2 border-gray-100 rounded-2xl focus:ring-2 focus:ring-sky-200 focus:border-sky-500 outline-none transition-all text-sm font-bold text-gray-800 shadow-sm";
  const labelStyle = "text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2 block ml-1";

  return (
    <div className="p-8 space-y-8 animate-fade-in-down">
      <div className="space-y-1">
          <h3 className="text-xl font-black text-gray-800 uppercase tracking-tight">Tus Datos de Contacto</h3>
          <p className="text-xs text-gray-500">Como Broker/Referidor, necesitamos tus datos oficiales para el seguimiento del incentivo.</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6">
        <div className="md:col-span-2">
          <label className={labelStyle}>Nombre completo del Broker*</label>
          <div className="relative">
              <UserCircleIcon className="absolute left-4 top-1/2 -translate-y-1/2 text-sky-600 w-5 h-5" />
              <input type="text" name="nombre_broker" value={formData.nombre_broker} onChange={onFormChange} placeholder="Nombre y Apellidos" className={inputClass} />
          </div>
        </div>

        <div>
          <label className={labelStyle}>Tipo de documento*</label>
          <select name="tipo_documento_broker" value={formData.tipo_documento_broker} onChange={onFormChange} className="w-full border-2 border-gray-100 rounded-2xl py-3 px-4 text-sm font-bold text-gray-800 focus:ring-2 focus:ring-sky-200 focus:border-sky-500 outline-none">
            {idTypes.map(t => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>

        <div>
          <label className={labelStyle}>Número de identificación*</label>
          <div className="relative">
              <IdentificationIcon className="absolute left-4 top-1/2 -translate-y-1/2 text-sky-600 w-5 h-5" />
              <input type="text" name="numero_documento_broker" value={formData.numero_documento_broker} onChange={onFormChange} placeholder="1.000.000.000" className={inputClass} />
          </div>
        </div>

        <div>
          <label className={labelStyle}>Teléfono Celular*</label>
          <div className="flex gap-2">
            <select value={formData.countryCode_broker} onChange={(e) => onFormChange({ target: { name: 'countryCode_broker', value: e.target.value } })} className="w-24 border-2 border-gray-100 rounded-2xl bg-gray-50 text-xs font-black uppercase px-2">
              {countryCodes.map(c => <option key={c.v} value={c.v}>{c.l}</option>)}
            </select>
            <div className="relative flex-grow">
                <DevicePhoneMobileIcon className="absolute left-4 top-1/2 -translate-y-1/2 text-sky-600 w-5 h-5" />
                <input type="tel" name="telefono_broker" value={formData.telefono_broker} onChange={onFormChange} placeholder="300 000 0000" className={inputClass} />
            </div>
          </div>
        </div>

        <div>
          <label className={labelStyle}>Correo electrónico*</label>
          <div className="relative">
            <EnvelopeIcon className="absolute left-4 top-1/2 -translate-y-1/2 text-sky-600 w-5 h-5" />
            <input type="email" name="email_broker" value={formData.email_broker} onChange={onFormChange} placeholder="tu@correo.com" className={inputClass} />
          </div>
        </div>
      </div>
    </div>
  );
};
